export const isDef = (v) => v !== undefined
